var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenWhiskIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-2.34 -0.42 64 64",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.375 52.474l-20.47-36.57-10.246 18.3L7.895 52.48z",
    fill: "#325c80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.375 52.474l10.245-18.28-20.48.007z",
    fill: "#5aaafa"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.65 10.686l10.336 18.272-20.483.01z",
    fill: "#6eedd8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.315 47.255L30.65 10.686l20.677-.007L61.66 28.964z",
    fill: "#008571"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenWhiskIcon);
export default __webpack_public_path__ + "static/media/openWhiskIcon.15463709823141a7ee4c761d0b24e0d1.svg";
export { ForwardRef as ReactComponent };